<template>
    <div class="body"
         v-infinite-scroll="loadmore"
         infinite-scroll-immediate="false">
        <div class="context">
            <header>
                <img src="../../../assets/images/mzlxx2020/header.jpg"
                     alt="我为母校送祝福">
                <div class="count-num">已有<strong>{{ animatedTotal }}</strong>人祝福</div>
                <div class="upload-button"
                     @click="openRecordVideo"></div>
            </header>
            <section class="title">
                <img src="../../../assets/images/mzlxx2020/title_6.png">
            </section>
            <section class="container">
                <div class="grid">
                    <waterfall :col='2'
                               :data="list">
                        <template>
                            <div class="grid-item item"
                                 :key="index"
                                 @click="watchVideo(item.id, item.newsId)"
                                 v-for="(item,index) in list">
                                <img :src="item.poster">
                                <div class="box-con">
                                    <div class="box-title"
                                         v-html="item.title"></div>
                                    <div class="box-company"
                                         v-if="item.company">
                                        <span>{{item.company}}</span>
                                    </div>
                                    <div class="box-love">
                                        <img class="box-header"
                                             :src="item.faceUrl">
                                        <div class="box-like">{{item.thumbUp}}</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </waterfall>
                </div>
                <div class="loading"
                     v-if="limit != 0">
                    <img src="../../../assets/images/mzlxx2020/loading.png"
                         alt="加载更多">
                    <p>下滑获取更多</p>
                </div>
                <div class="loading"
                     v-if="limit == 0">
                    <p>已经加载全部内容</p>
                </div>
            </section>
        </div>

        <section>
            <a href="javascript:void(0);"
               @click="openRecordVideo">
                <img class="i-button"
                     src="../../../assets/images/mzlxx2020/i-button.png"></a>
        </section>

    </div>
</template>

<script>
import TweenLite from 'gsap';
import jsonp from 'jsonp';

export default {
    data () {
        return {
            lastUserName: '',
            company: [],
            currentCompanyIndex: 0,
            total: 0,
            tweenedTotal: 0,
            list: [],
            col: 2,
            limit: 10,
            page: 1,
            isLoading: false
        }
    },
    computed: {
        animatedTotal: function () {
            return this.tweenedTotal.toFixed(0);
        }
    },
    watch: {
        total (newValue) {
            TweenLite.to(this.$data, 0.5, { tweenedTotal: newValue });
        },
        page () {
            this.isLoading = true
            this.axios.get('/webtopic/videoList/171?limit=' + this.limit + '&page=' + this.page).then((res) => {
                if (res.data.data.length) {
                    this.list = this.list.concat(this.dataMap(res.data.data))
                } else {
                    this.limit = 0
                }
            }).finally(() => {
                this.isLoading = false
            })
        }
    },
    methods: {
        dataMap (data) {
            return data.map((item) => {
                item.topic = []
                item.company = ''

                if (item.title) {
                    const reg1 = new RegExp('#[^ ]+(?= |\\s)', 'g')
                    item.title = item.title.replace(reg1, '<em>$&</em>')

                    const reg2 = new RegExp('\\(.*?\\)', 'g')

                    let company = item.title.match(reg2)
                    item.title = item.title.replace(reg2, '')

                    if (company) {
                        item.company = company[0].replace('(', '').replace(')', '')
                        if (item.company && this.company.indexOf(item.company) == -1) {
                            this.company.push(item.company)
                        }
                    }
                }
                return item;
            });
        },
        init () {
            this.isLoading = true
            this.axios.get('/webtopic/videoInit/171?limit=' + this.limit + '&page=' + this.page).then((res) => {
                const data = res.data.data
                this.lastUserName = data.lastUserName;
                this.total = data.total;

                this.limit = data.list.length < this.limit ? 0 : 10;

                if (this.page == 1) {
                    this.list = this.dataMap(data.list)
                }
            }).finally(() => {
                this.isLoading = false
            })
        },
        loadmore () {
            if (this.limit != 0 && !this.isLoading) {
                this.page++
            }
        },
        openRecordVideo () {
            this.$openZGApp("zgapp://gxnews.com.cn:8765/feature?type=0", "https://fun.gxnews.com.cn/zg/")
        },
        watchVideo (videoId, ItemId) {
            this.$openZGApp("zgapp://gxnews.com.cn:8765/browser?type=video&itemId=" + ItemId, "http://zgapp.gxnews.com.cn/h5/#/video/" + videoId)
        },
        getStatistPv () {
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=${encodeURIComponent('https://zgapp.gxnews.com.cn/h5/#/video-mzlxx2020')}&tag=zgapp-video&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })
        }
    },
    mounted () {
        document.title = "南宁市民主路小学建校65周年校庆——我为母校送祝福";
        this.init();

        setInterval(() => {
            if (this.company.length - 1 <= this.currentCompanyIndex) {
                this.currentCompanyIndex = 0;
            } else {
                this.currentCompanyIndex++
            }
        }, 3000)

        this.$nextTick(() => {
            this.$bus.$emit('hideDownload', true)
        });
        this.getStatistPv();
    }
}
</script>

<style scoped>
.body {
    height: 100%;
    max-width: 64rem;
    font-size: 0.32rem;
    overflow-x: hidden;
}

.context {
    /*background: url("../../../assets/images/mzlxx2020/bg.jpg") center top/2rem
        auto repeat;*/
}

.i-button {
    width: 1.853333rem;
    position: fixed;
    right: 0.32rem;
    bottom: 1.186667rem;
}

.loading {
    color: #fff;
    text-align: center;
    line-height: 0.8rem;
    padding-top: 0.4rem;
}

.loading img {
    display: block;
    width: 0.986667rem;
    margin: 0 auto;
    animation: rotate 1s linear infinite;
}
@keyframes rotate {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

header {
    position: relative;
}

header img {
    width: 100%;
    display: block;
}

header .count-num {
    position: absolute;
    width: 100%;
    text-align: center;
    color: #fff;
    line-height: 0.8rem;
    top: 7.3rem;
}

header .count-num strong {
    color: #fa4040;
    font-size: 0.4rem;
}

header .upload-button {
    position: absolute;
    top: 8.2rem;
    left: 30%;
    background: url("../../../assets/images/mzlxx2020/push.png") center
        right/auto 0.74667rem no-repeat;
    width: 3.933333rem;
    margin: 0 auto;
    height: 0.8rem;
    margin-bottom: 1.066667rem;
}

header .new-tips {
    background: url("../../../assets/images/yiqing/i-header.png") center
        right/auto 0.74667rem no-repeat;
    color: #fff;
    height: 0.746667rem;
    line-height: 0.746667rem;
    position: absolute;
    top: 0.96rem;
    left: 0;
    padding-left: 0.266667rem;
    padding-right: 0.533333rem;
}

.title {
    padding-top: 0.506667rem;
    padding-bottom: 0.506667rem;
    background-image: -webkit-gradient(linear,left top,left bottom,color-stop(6rem,#fff),to(rgba(255,255,255,0)));
    background-image: -webkit-linear-gradient(top,#fff 6rem,rgba(255,255,255,0) 100%);
    background-image: linear-gradient(to bottom,#fff 6rem,rgba(255,255,255,0) 100%)
}

.title img {
    display: block;
    width: 100%;
}

.container {
    min-height: 10rem;
    background: url("../../../assets/images/mzlxx2020/footer.jpg") center
        bottom no-repeat;
        background-size: contain;
}

.grid {
    width: 96%;
    margin: 2% auto;
    overflow: hidden;
    position: relative;
}

.grid-item {
    margin: 0 0.1rem;
    /* float: left; */
    border-radius: 0.12rem 0.12rem 0 0;
    background: #fff;
    /* width: 48%; */
    margin-bottom: 0.333333rem;
    overflow: hidden;
}

.grid-item img {
    width: 100%;
    display: block;
}

.grid-item .box-con {
    /*background: url("../../../assets/images/yiqing/i-point.png") 0.13333rem
        0.37333rem/0.44rem 0.6rem no-repeat;*/
    font-size: 0.346667rem;
    line-height: 0.533333rem;
    padding: 0.266667rem 0.266667rem 0.266667rem 0.266667rem;
    overflow: hidden;
}

.grid-item .box-title {
    border-bottom: 1px dashed #b5b5b5;
    font-weight: bold;
    padding-bottom: 0.333333rem;
    margin-bottom: 0.333333rem;
}

.grid-item .box-title >>> em {
    color: #b04b58;
    font-style: normal;
}

.grid-item .box-company {
    font-size: 0.32rem;
    margin-bottom: 0.333333rem;
}

.grid-item .box-header {
    width: 0.96rem;
    height: 0.96rem;
    border-radius: 50%;
    float: left;
}

.grid-item .box-love {
    overflow: hidden;
}

.grid-item .box-like {
    background: url("../../../assets/images/mzlxx2020/i-love-red.png") 0.13333rem
        0.10667rem/0.44rem no-repeat #fea802;
    cursor: pointer;
    border-radius: 0.293333rem;
    color: #fefbf7;
    height: 0.586667rem;
    line-height: 0.586667rem;
    font-size: 0.266667rem;
    float: right;
    padding: 0 0.293333rem 0 0.666667rem;
    margin-top: 0.186667rem;
}

.fix-bottom {
    background: url("../../../assets/images/mzlxx2020/bg-bottom.png") center
        top/100%;
    height: 1.6rem;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding-top: 0.333333rem;
    display: flex;
    justify-content: space-around;
}

.fix-bottom .com-log {
    background: url("../../../assets/images/yiqing/i-love-red.png") 0.17333rem
        center/0.50667rem 0.45333rem no-repeat #fff;
    border-radius: 0.626667rem;
    width: 7.52rem;
    height: 0.773333rem;
    line-height: 0.773333rem;
    padding: 0.24rem 0 0.24rem 0.746667rem;
}

.fix-bottom .com-log .com-word {
    color: #850404;
    font-size: 0.373333rem;
    border-right: 1px solid #850404;
    padding-right: 0.08rem;
    margin-right: 0.08rem;
    float: left;
}

.fix-bottom .com-log .com-log-tip {
    width: 4.506667rem;
    text-align: center;
    color: #4f4848;
    line-height: 0.36rem;
    float: left;
}

.fix-bottom .com-log .com-log-tip strong {
    color: #cc0101;
}

.fix-bottom .company-list {
    border-radius: 0.4rem;
    background: #850404;
    color: #fff;
    line-height: 0.773333rem;
    height: 0.773333rem;
    padding: 0.24rem 0.066667rem;
}
</style>
